<template>
	<div class="skipass">
		<PageLoading v-if="pageLoading" />
		<div class="skipass__search">
			<!-- Search - date, type & campaign code -->
			<div v-if="!pageLoading" class="skipass__search-inputs">
				<div class="grid-container">
					<div class="grid-x grid-margin-x">
						<div class="cell small-12 medium-12 large-8">
							<h1>{{ $t('skipass.heading') }}</h1>
						</div>
					</div>

					<div class="grid-x grid-margin-x">
						<!-- Date -->
						<div class="cell small-12 medium-6 large-4">
							<div class="skipass__search-date">
								<CalenderToggle
									:placeholderValue="$t('skipass.placeholderStartDate')"
									:lightTheme="true"
									:label="$t('skipass.labelStartDate')"
									:icon="inputIcon"
									:value="
										this.selectedStartDate
											? this.selectedStartDate
											: this.accommodation.length
											? this.accommodation[0].arrdate
											: this.selectedStartDate
									"
									:iconPlacement="inputIconPlacement"
									:isLoading="loading"
									:mandatory="true"
									@click.native="showDatepicker = !showDatepicker"
								/>
								<DatePicker
									v-if="showDatepicker"
									:selectForward="true"
									:format="'YYYY-MM-DD'"
									:singleDaySelection="true"
									:monthList="$t('datepicker.monthList')"
									:placeholder="$t('datepicker.selectDateRange')"
									:startdateHelptext="$t('datepicker.selectStartDate')"
									:singleCalendar="true"
									:dropdown="true"
									@update="update"
									:startDate="this.selectedStartDate"
									:minDate="getMinDate()"
									:maxDate="getMaxDate()"
									:noDates="disableDates"
									:allowedDates="availableDates"
								/>

								<!-- <div class="datepicker-alert">
									<AlertMessage :show="disableDatepicker" :blue="true">
										{{ $t('search.datepickerAlertText') }}
										Det finns inga bokningsbara datum.
									</AlertMessage>
								</div> -->
							</div>
						</div>

						<!-- Type -->
						<div class="cell small-12 medium-6 large-3">
							<div>
								<Select
									:value="
										selectedFilterType ? selectedFilterType.id.toString() : ''
									"
									:placeholder="$t('skipass.placeholderType')"
									:option-items="
										filterTypes.map(item => {
											return { id: item.id, text: item.label, type: item.type }
										})
									"
									:lightTheme="true"
									:label="$t('skipass.labelType')"
									@input="setType"
									:defaultDisabled="false"
									:isDisabled="filterTypes.length == 0 || loading"
								/>
							</div>
						</div>

						<!-- Campaign code - Mobile -->
						<div
							class="skipass__search-campaign cell small-12 medium-6 large-3 large-offset-2 hide-for-medium"
						>
							<button
								class="link-button link-button--centered"
								:disabled="filterTypes.length == 0 || loading"
								v-if="showCampainCodeInputForMobile == false"
								@click="showCampainCodeInputForMobile = true"
							>
								<svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon icon-notification'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M6.055 14V7.925H0V6.04h6.055V0h1.82v6.04H14v1.885H7.875V14z" fill="CurrentColor" fill-rule="evenodd"/></svg>
								{{ $t('skipass.placeholderCampaign') }}
							</button>
							<InputComponent
								v-if="showCampainCodeInputForMobile"
								v-model="campaignCode.value"
								:placeholderValue="$t('skipass.placeholderCampaign')"
								:lightTheme="true"
								:label="$t('skipass.placeholderCampaign')"
								:hasError="campaignCode.error"
								:errorMessage="campaignCode.message"
								:accepted="campaignCode.accepted"
								:isDisabled="campaignCode.disabled || loading"
							>
								<Button
									@click.native="updateCampainCode"
									class="campaign__button btn--button-like-behavior"
									size="small"
								>
									<svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon icon-notification'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M6.055 14V7.925H0V6.04h6.055V0h1.82v6.04H14v1.885H7.875V14z" fill="CurrentColor" fill-rule="evenodd"/></svg>
								</Button>
							</InputComponent>
						</div>

						<!-- Campaign code -->
						<div
							class="skipass__search-campaign cell small-12 medium-6 large-3 large-offset-2 show-for-medium"
						>
							<InputComponent
								v-model="campaignCode.value"
								:placeholderValue="$t('skipass.placeholderCampaign')"
								:lightTheme="true"
								:label="$t('skipass.placeholderCampaign')"
								:hasError="campaignCode.error"
								:errorMessage="campaignCode.message"
								:accepted="campaignCode.accepted"
								:isDisabled="campaignCode.disabled || loading"
							>
								<Button
									@click.native="updateCampainCode"
									class="campaign__button btn--button-like-behavior"
									size="small"
								>
									<svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon icon-notification'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M6.055 14V7.925H0V6.04h6.055V0h1.82v6.04H14v1.885H7.875V14z" fill="CurrentColor" fill-rule="evenodd"/></svg>
								</Button>
							</InputComponent>
						</div>

						<div class="cell small-12 medium-6 large-4">
							<div class="skipass__search-alert">
								<AlertMessage :show="true" :blue="true">
									<p>
										{{ $t('skipass.alertMessageGondola') }} <a target="_blank" :href="$t('skipass.alertMessageGondolaLinkUrl')">{{ $t('skipass.alertMessageGondolaLinkText') }}</a>.
									</p>
								</AlertMessage>
							</div>
						</div>

					</div>
				</div>
			</div>
			<div ref="result"><!-- scroll ref --></div>
			<FilterList
				:filterCategorys="[
					filterCategorys.categories,
					filterCategorys.equipmentCategories
				]"
				:labels="[]"
				:show="skipasses.length > 0"
			/>
		</div>

		<!-- Search result -->
		<div
			class="skipass__result"
			v-if="this.skipasses.length != 0"
			:class="loading ? 'skipass__result--loading' : true"
		>
			<CardList
				v-if="skipasses.length > 0"
				:cardType="'skipass'"
				:cards="skipasses"
				:startDate="selectedStartDate"
				:keycardPrice="keycardPrice"
				@openDatepicker="showDatepicker = true"
			/>
		</div>

		<!-- No search result -->
		<div v-if="showNoResults" class="grid-container">
			<div class="grid-x cell small-12">
				<div class="skipass__no-result">
					<h2>{{ $t('emptyStates.noResultsHeading') }}</h2>
					<p>{{ $t('emptyStates.noResultsSkipassText') }}</p>
					<Button @click.native="scrollAndFocus()" size="small">
						{{ $t('emptyStates.noResultsButtonText') }}
					</Button>
				</div>
			</div>
		</div>

		<!-- Summary popup -->
		<transition name="slide-up">
			<ProductSummaryBar
				v-if="selectedItems.length != 0"
				@on-add="addToCart"
				:bookingType="productSummaryBarType"
			/>
		</transition>

		<!-- Modal - Add to cart reminder -->
		<AddToCartModal
			v-if="showCartReminderModal"
			:title="$t('cart.reminderModalTitle')"
			:text="$t('cart.reminderModalText')"
			:buttons="[
				{ type: 'addLeave', color: '' },
				{ type: 'clearLeave', color: 'primary4' }
			]"
			:routeTo="to"
			@close="showCartReminderModal = false"
		/>

		<!-- Empty state -->
		<EmptyState
			v-if="!showNoResults"
			:type="'skipass'"
			:heading="skipassHeading"
			:preamble="skipassPreamble"
			:bodytext="skipassBodytext"
			:linktext="$t('emptyStates.skipassLinktext')"
		>
			<template v-slot:rightBoxes>
				<div class="grid-x grid-margin-x">
					<div
						class="cell small-12 medium-12 large-7 large-offset-5"
						v-if="!isLoggedIn()"
					>
						<InfoBox
							:heading="$t('emptyStates.profileHeading')"
							:bodytext="$t('emptyStates.profileBodytext')"
							cta="newaccount"
							textLink="login"
							theme="light"
							level="secondary"
							:lastChild="true"
						/>
					</div>
				</div>
			</template>
		</EmptyState>

		<!-- Modal - Add to cart -->
		<!-- <AddToCartModal
			v-if="showCartModal"
			:title="$t('cart.cartModalTitle')"
			:text="$t('cart.cartModalText')"
			:buttons="[
				{ type: 'close', color: 'primary4' },
				{ type: 'add', color: '' }
			]"
			@close="showCartModal = false"
		/> -->
	</div>
</template>

<script>
import store from '../vueX/store'
import mixin from '../mixin'

import PageLoading from '../components/atoms/PageLoading'
import DatePicker from '../components/molecules/DatePicker'
import Select from '../components/atoms/Select'
import FilterList from '../components/molecules/FilterList'
import CardList from '../components/molecules/CardList'
import CalenderToggle from '../components/atoms/CalenderToggle'
import ProductSummaryBar from '../components/molecules/ProductSummaryBar'
import AddToCartModal from '../components/molecules/AddToCartModal'
import EmptyState from '../components/molecules/EmptyState'
import InfoBox from '../components/molecules/InfoBox'
import Button from '../components/atoms/Button.vue'
import AlertMessage from '../components/atoms/AlertMessage'
import InputComponent from '../components/atoms/InputComponent'
// import moment from 'moment'

export default {
	name: 'Skipass',
	store,
	mixins: [mixin],
	components: {
		PageLoading,
		DatePicker,
		CardList,
		CalenderToggle,
		Select,
		AddToCartModal,
		FilterList,
		ProductSummaryBar,
		EmptyState,
		InfoBox,
		Button,
		InputComponent,
		AlertMessage
	},
	data() {
		return {
			filterCategorys: {},
			// campaignCode: '',
			campaignCode: {
				value: '',
				message: '',
				show: false,
				error: false,
				accepted: false,
				disabled: true
			},
			filterTypes: [],
			showDatepicker: false,
			disableDates: false,
			filters: [],
			typeFilter: null,
			inputIcon: 'calendar_k_ico_24x24.svg',
			inputIconPlacement: 'right',
			skipassesClone: [],
			skipasses: [],
			selectedStartDate: '',
			selectedFilters: [],
			selectedCategories: [],
			keycardPrice: null,
			productSummaryBarType: 'skipass',
			loading: false,
			showCartReminderModal: false,
			showCartModal: false,
			showNoResults: false,
			to: null,
			check: true,
			pageLoading: false,
			availableDates: [],
			keyCardPrice: 0,
			showCampainCodeInputForMobile: false,
			skipassHeading: '',
			skipassPreamble: '',
			skipassBodytext: ''
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.selectedItems.length > 0 && to.name != 'addtocart') {
			this.showCartReminderModal = true
			this.to = to
			this.to.query.cc =
				this.campaignCode.value !== '' ? this.campaignCode.value : undefined
		} else {
			store.dispatch('CLEAR_PRODUCT_FILTERS_AND_ITEMS')
			next()
		}
	},
	computed: {
		accommodation() {
			return store.state.cart.accommodation
		},
		selectedFilterType() {
			return store.state.productList.selectedFilterType
		},
		selectedItems() {
			return store.state.productList.selectedItems
		}
	},
	methods: {
		getMaxDate() {
			let endDate = this.availableDates[this.availableDates.length - 1]
			return endDate
		},
		getMinDate() {
			const minDate = this.availableDates[0]
			return minDate
		},
		addToCart() {
			store
				.dispatch('ADD_CART_SKIPASS', store.state.productList.selectedItems)
				.then(() => {
					this.$router.push({ name: 'addtocart' })
				})
		},
		isLoggedIn() {
			return store.state.user != null
		},
		updateCampainCode() {
			const query = { ...this.$route.query, cc: this.campaignCode.value }
			this.$router.replace({ query })
			this.update()
		},
		update(data) {
			//const query = this.$route.query
			if (data != null && data.start !== undefined) {
				this.selectedStartDate = data.start
			}

			if (data != null && data.end !== undefined) {
				this.selectedEndDate = data.end
			}

			this.showDatepicker = false
			this.loading = true
			this.skipasses = []

			this.campaignCode.message = ''
			this.campaignCode.error = false

			return store
				.dispatch('GET_SKIPASS', {
					startDate: this.selectedStartDate,
					campaignCode:
						this.campaignCode.value !== '' ? this.campaignCode.value : undefined //query.cc ? query.cc : undefined
				})
				.then(success => {
					if (success) {
						this.$scrollTo(this.$refs.result, 500, { offset: -60 })
						// Add start and end date to ages
						success.items.forEach(each => {
							each.ages = each.ages.map(each =>
								Object.assign(each, {
									startDate: this.selectedStartDate,
									endDate: this.selectedEndDate
								})
							)
						})

						this.filterCategorys = success.filters
						this.filterTypes = success.filters.skipassTypes
						this.skipassesClone = [...success.items]
						this.skipasses = success.items
						this.keycardPrice = success.keycardPrice

						this.loading = false
						this.campaignCode.disabled = false

						// If result is empty show it to the user
						this.showNoResults = success.items.length === 0
					} else {
						this.loading = false
						this.campaignCode.disabled = false

						// Error message
						if (this.campaignCode.value) {
							this.campaignCode.message = this.$t('search.errorCampaignCode')
							this.campaignCode.error = true
						}
					}
				})
		},
		setType(typeID) {
			let type = this.filterTypes.find(each => each.id == typeID)

			store.dispatch('PRODUCT_SELECTED_FILTER_TYPE', type)
		},
		//checks todays date and startdate, if they are the same or after then a limit should be set.
		// limitStartDate(fromdate) {
		// 	const todayDate = moment(new Date()).format('YYYY-MM-DD')
		// 	const shouldAddLimit = moment(todayDate).isSameOrAfter(fromdate, 'day')
		// 	if (shouldAddLimit) {
		// 		const newFromDate = moment(todayDate)
		// 			.add(this.availableDates.limit, 'days')
		// 			.format('YYYY-MM-DD')
		// 		this.availableDates.fromdate = newFromDate
		// 	}
		// },
		queryToState() {
			const querys = this.$route.query
			this.selectedStartDate = querys.s ? querys.s : this.startDate
			this.selectedEndDate = querys.e ? querys.e : this.endDate
			this.campaignCode.value = querys.cc ? querys.cc : this.campaignCode.value
		},
		scrollAndFocus() {
			window.scrollTo(0, 0)
			this.showDatepicker = true
		}
	},
	mounted: function () {
		// If you have a accomodation in the cart
		if (this.accommodation.length) {
			const query = this.$route.query
			//If there is an available period, do a search
			store
				.dispatch('GET_AVAILABLE_SKIPASS', {
					campaignCode: query.cc ? query.cc : undefined
				})
				.then(success => {
					if (success) {
						const dates = Array.isArray(success) ? success : success.dates // ToDo: Fast fix to support both old and the supposed to be new feature change this when the model is set in stone.
						if (dates.length > 0) {
							this.selectedStartDate = this.accommodation[0].arrdate
							this.update({ start: this.accommodation[0].arrdate })
						}

						this.skipassHeading = success.textResources[0].title
						this.skipassPreamble = success.textResources[0].preamble
						this.skipassBodytext = success.textResources[0].body
					}

					// ToDo: implament campainCode error checking here
				})
		}
	},
	created: function () {
		const query = this.$route.query
		this.queryToState()

		//visar laddnings symbol innan tillgänliga datum för skipass hämtas
		this.pageLoading = true

		if (query.s != undefined) {
			if (
				this.selectedStartDate !== undefined &&
				this.selectedStartDate !== null &&
				this.selectedStartDate !== ''
			) {
				this.update().then(success => {
					if (success) {
						if (success.length == 0) {
							this.disableDates = true
							this.pageLoading = false
						} else {
							if (Array.isArray(success)) {
								// ToDo: Fast fix to support both old and the supposed to be new feature change this when the model is set in stone.
								this.availableDates = success[0]
								//this.limitStartDate(success[0].fromdate)
							} else {
								this.availableDates = success.dates
								// this.availableDates = success.dates[0]
								//this.limitStartDate(success.dates[0].fromdate)
							}

							this.pageLoading = false
						}
					} else {
						this.pageLoading = false
					}

					if (this.availableDates.length == 0) {
						this.disableDates = true
					}
				})
			}
		} else {
			store
				.dispatch('GET_AVAILABLE_SKIPASS', {
					campaignCode: query.cc ? query.cc : undefined
				})
				.then(success => {
					if (success) {
						if (success.length == 0) {
							this.disableDates = true
							this.pageLoading = false
						} else {
							this.availableDates = success.dates
							//this.availableDates = success.dates[0]
							//this.limitStartDate(success.dates[0].fromdate)

							this.skipassHeading = success.textResources[0].title
							this.skipassPreamble = success.textResources[0].preamble
							this.skipassBodytext = success.textResources[0].body
							this.pageLoading = false
						}
					} else {
						this.pageLoading = false
					}

					if (this.availableDates.length == 0) {
						this.disableDates = true
					}
				})
		}
	}
}
</script>

<style lang="scss">
.skipass {
	&__search {
		background: #f4f5f7;
		padding: 20px 0 0 0;
		@include for-tablet-portrait-up {
			padding: 40px 0 0 0;
		}

		h1 {
			font-family: Saira;
			font-size: 28px;
			color: #434449;
			line-height: 1.4;
			font-weight: 400;
			margin-bottom: 15px;
		}
		&-inputs {
			padding: 0 0 25px 0;
			.input__container,
			.select__container {
				margin-bottom: 10px;
			}
		}
		&-date {
			position: relative;
			@include for-tablet-portrait-up {
				max-width: 310px;
			}
		}

		&-campaign {
			.input__label-text {
				visibility: hidden;
			}

			.input__label {
				height: 40px;
			}

			.input__container {
				@include for-tablet-portrait-up {
					max-width: 310px;
				}
			}

			// ToDo: make this into a component
			.link-button {
				background: none;
				border: none;
				padding: 0;
				color: #04befb;
				text-decoration: underline;
				cursor: pointer;
				padding-left: 20px;
				position: relative;
				margin-top: 10px;

				&--centered {
					left: 50%;
					transform: translateX(-50%);
				}

				&:disabled,
				&[disabled] {
					color: #808080;
					cursor: unset;
				}

				svg {
					color: #04befb;
					position: absolute;
					left: 0;
					top: 50%;
					transform: translateY(-50%);
				}
			}
		}

		.campaign {
			&__button {
				background: $colorSecondary;

				svg {
					transform: scale(1.8);
				}
			}
		}
		&-checkboxes {
			background: $colorPrimary1;
			padding: 35px 0 29px;
			.checkbox-button {
				vertical-align: middle;
			}
		}
		&-clear {
			float: right;
		}

		&-alert {
			margin-top: 15px;

			@include for-tablet-portrait-up {
				max-width: 310px;
			}
		}
	}

	&__empty-state {
		padding-top: 40px;
		height: 200px;
	}

	&__result {
		padding: 15px 0;
		&--loading {
			position: relative;
			overflow: hidden;
			&:after {
				content: '';
				width: 100%;
				height: 100%;
				display: block;
				position: absolute;
				top: 0;
				left: 0;
				background: rgba(0, 0, 0, 0.3);
				z-index: 100;
			}
		}

		&__no-results {
			margin-top: 60px;

			p {
				margin-top: 19px;
			}

			button {
				margin-top: 30px;
			}
		}
	}

	&__no-result {
		margin: 60px 0;

		p {
			margin-top: 19px;
		}

		button {
			margin-top: 30px;
		}
	}

	@include for-tablet-landscape-up {
	}
}
</style>
